@let data = section();

<section class="cms-tabs tg-container tg-section" [class.cms-tabs--vertical]="isVertical()">
    @if (data.content) {
        <div class="cms-tabs__intro cms-content" [innerHTML]="data.content | trustHtml"></div>
    }

    @if (data.tabsItems.length) {
        <div class="cms-tabs__wrap">
            <div class="cms-tabs__list" role="tablist">
                @for (item of data.tabsItems; track item.id) {
                    <button
                        class="cms-tabs__tab"
                        type="button"
                        role="tab"
                        [id]="'tab-' + item.id"
                        [class.cms-tabs__tab--active]="activeTabId() === item.id"
                        [attr.aria-selected]="activeTabId() === item.id"
                        [attr.aria-controls]="'panel-' + item.id"
                        (click)="selectTab(item.id)"
                    >
                        {{ item.itemLabel }}
                    </button>
                }
            </div>

            <div
                class="cms-tabs__panel"
                role="tabpanel"
                [id]="'panel-' + activeTabId()"
                [attr.aria-labelledby]="'tab-' + activeTabId()"
            >
                <div class="cms-content" [innerHTML]="activeContent() | trustHtml"></div>
            </div>
        </div>
    }
</section>
